<!--
 * @Author: zl
 * @Date: 2021-09-22 11:47:22
 * @LastEditTime: 2023-08-31 14:12:38
 * @LastEditors: Please set LastEditors
 * @Description: 摄像头管理
-->
<template>
	<div class="Camera-Management-layout">
		<div class="operation-layout" v-show="!showDetails">
			<el-form label-width="120px" class="w100 mt10" size="small">
				<el-row class="header-msg">
					<el-col :span="4">
						<p class="header-title">
							会议室信息
						</p>
					</el-col>
					<el-col :span="20">
						<el-col :span="12">
							<span>会议室名称：</span>
							<span>{{ metObj.sname }}</span>
						</el-col>
						<el-col :span="12">
							<span>会议室类型：</span>
							<span>{{ metObj.typeName }}</span>
						</el-col>
						<el-col :span="12">
							<span>所属场地名称：</span>
							<span>{{ msgObj.sname }}</span>
						</el-col>
						<el-col :span="12">
							<span>场地地址：</span>
							<span>{{ msgObj.detailAdd }}</span>
						</el-col>
					</el-col>
				</el-row>
			</el-form>
			<div class="operation-main">
				<div class="operation-header">
					<div class="left-title">
						<span class="header-title">
							监控设备列表
						</span>
					</div>
					<div class="btnGroups">
						<el-button
							size="small"
							type="primary"
							class="btn-blue"
							icon="el-icon-plus"
							v-if="roleBtns.includes('camera-add') && msgObj.tag != '1001002'"
							@click="addCamera"
							>添加监控设备
						</el-button>
					</div>
				</div>
				<div class="operation-container w-table-layout w-table-page">
					<div class="w-table-content">
						<vxe-table
							align="center"
							auto-resize
							ref="cameraList"
							resizable
							border
							size="small"
							v-if="tableShow"
							:loading="loading"
							:data="cameraData"
							height="100%"
							show-overflow="tooltip"
							show-header-overflow="tooltip"
							highlight-current-row
							highlight-hover-row
						>
							<vxe-table-column type="seq" title="序号" width="60"></vxe-table-column>
							<vxe-table-column
								field="cameraName"
								title="监控设备名称"
								header-align="center"
								align="left"
								min-width="180"
							></vxe-table-column>
							<vxe-table-column field="location" title="安装位置" width="180"></vxe-table-column>
							<vxe-table-column field="brand" title="设备品牌" width="150"></vxe-table-column>
							<vxe-table-column field="model" title="设备型号" width="150"></vxe-table-column>
							<vxe-table-column field="serialNo" title="设备序列号" width="150"></vxe-table-column>
							<vxe-table-column field="cameraIp" title="录像机IP" width="150"></vxe-table-column>
							<vxe-table-column field="cameraNo" title="录像机账号" width="150"></vxe-table-column>
							<vxe-table-column field="cameraCode" title="录像机密码" width="150"></vxe-table-column>
							<vxe-table-column field="portNum" title="通道数" width="100"></vxe-table-column>
							<vxe-table-column field="portSerial" title="通道序列号" width="150"></vxe-table-column>
							<vxe-table-column field="portNo" title="通道号" width="100"></vxe-table-column>
							<vxe-table-column field="previewUrl" title="预览地址" minWidth="200">
								<!-- <template #default="{ row }">
									<span class="cursor-pointer color-blue" @click="openUrl(row.previewUrl)">{{ row.previewUrl || '' }}</span>
								</template> -->
							</vxe-table-column>
							<vxe-table-column field="status" title="启用状态" width="120">
								<template v-slot="{ row }">
									<vxe-switch
										v-model="row.status"
										open-label="启用"
										:open-value="1"
										close-label="禁用"
										:close-value="0"
										@change="statusChange(row)"
									></vxe-switch>
								</template>
							</vxe-table-column>
							<vxe-table-column title="操作" min-width="180" width="180px">
								<template #default="{ row }">
									<el-button type="primary" plain round class="table-btn" icon="el-icon-view" @click="doClick(row, 'view')"
										>查看
									</el-button>
									<el-button
										type="success"
										plain
										round
										class="table-btn"
										icon="el-icon-edit"
										v-if="msgObj.tag != '1001002'"
										@click="doClick(row, 'edit')"
										>编辑
									</el-button>
								</template>
							</vxe-table-column>
						</vxe-table>
					</div>
					<div class="w-table-footer">
						<vxe-pager
							size="mini"
							:current-page="cameraPage"
							:page-size="cameraPageSize"
							:total="cameraTotal"
							:layouts="['PrevPage', 'JumpNumber', 'NextPage', 'FullJump', 'Sizes', 'Total']"
							class="text-center"
							:page-sizes="[10, 20, 50, 100]"
							@page-change="cameraPageChange"
						>
						</vxe-pager>
					</div>
				</div>
			</div>
		</div>

		<!-- 摄像头详情 -->
		<div class="operation-layout" v-show="showDetails">
			<el-form label-width="120px" class="w100 mt10" size="small">
				<el-row class="header-msg">
					<el-col :span="24">
						<p class="header-title">监控设备信息</p>
					</el-col>
				</el-row>
				<el-row :gutter="10">
					<el-col :span="24">
						<el-col :span="5" :sm="8">
							<span>品牌：</span>
							<span>{{ viewObj.brand }}</span>
						</el-col>
						<el-col :span="7" :sm="8">
							<span>安装位置：</span>
							<span>{{ viewObj.location }}</span>
						</el-col>
						<el-col :span="4" :sm="8">
							<span>录像机Ip：</span>
							<span>{{ viewObj.cameraIp }}</span>
						</el-col>
						<el-col :span="8" :sm="8">
							<span>通道序列号：</span>
							<span>{{ viewObj.portSerial }}</span>
						</el-col>
						<el-col :span="5" :sm="8">
							<span>型号：</span>
							<span>{{ viewObj.model }}</span>
						</el-col>
						<el-col :span="7" :sm="8">
							<span>所属会议室：</span>
							<span>{{ metObj.sname }}</span>
						</el-col>
						<el-col :span="4" :sm="8">
							<span>录像机账号：</span>
							<span>{{ viewObj.cameraNo }}</span>
						</el-col>
						<el-col :span="8" :sm="8">
							<span>通道号：</span>
							<span>{{ viewObj.portNo }}</span>
						</el-col>
						<el-col :span="5" :sm="8">
							<span>序列号：</span>
							<span>{{ viewObj.serialNo }}</span>
						</el-col>
						<el-col :span="7" :sm="8">
							<span>所属场地：</span>
							<span>{{ msgObj.sname }}</span>
						</el-col>
						<el-col :span="4" :sm="8">
							<span>录像机密码：</span>
							<span>{{ viewObj.cameraCode }}</span>
						</el-col>
						<el-col :span="8" :sm="8" class="text-overflow">
							<span>预览地址：</span>
							<span :title="viewObj.previewUrl">{{ viewObj.previewUrl }}</span>
						</el-col>
						<el-col :span="5" :sm="8">
							<span>状态：</span>
							<span class="red" v-if="viewObj.status == 0">禁用</span>
							<span class="green" v-if="viewObj.status == 1">启用</span>
						</el-col>
						<el-col :span="7" :sm="8" class="text-overflow">
							<span>所属公司：</span>
							<span :title="msgObj.tenantSname">{{ msgObj.tenantSname }}</span>
						</el-col>
						<el-col :span="4" :sm="8">
							<span>录像机通道数：</span>
							<span>{{ viewObj.portNum }}</span>
						</el-col>
					</el-col>
				</el-row>
			</el-form>
			<div class="operation-main">
				<div class="operation-header">
					<div class="left-title">
						<span class="header-title">监控视频信息</span>
					</div>
				</div>
				<div class="operation-container">
					<div class="w-table-layout w-table-page">
						<div class="w-table-content">
							<vxe-table
								align="center"
								auto-resize
								ref="cameraList"
								resizable
								border
								size="small"
								v-if="tableShow"
								:loading="loading"
								:data="videoData"
								height="100%"
								show-overflow="tooltip"
								show-header-overflow="tooltip"
								highlight-current-row
								highlight-hover-row
							>
								<vxe-table-column type="seq" title="序号" width="60"></vxe-table-column>
								<vxe-table-column
									field="tenderProjectName"
									title="招标项目名称"
									header-align="center"
									align="left"
									min-width="200"
								></vxe-table-column>
								<vxe-table-column field="lifeName" title="标段名称" header-align="center" align="left" min-width="150">
								</vxe-table-column>
								<vxe-table-column title="录制时段" width="300">
									<template #default="{ row }">
										<span>{{ row.captureStartTime + ' ~ ' + row.captureEndTime }}</span>
									</template>
								</vxe-table-column>
								<vxe-table-column field="type" title="录制方式" width="100">
									<template #default="{ row }">
										<span>{{ row.capturType == 1 ? '自动截取' : '手动截取' }}</span>
									</template>
								</vxe-table-column>
								<vxe-table-column field="updateUserName" title="操作人" width="110"></vxe-table-column>
								<vxe-table-column field="updateDate" title="操作时间" width="160"></vxe-table-column>
								<vxe-table-column title="操作" width="100">
									<template #default="{ row }">
										<el-button
											type="primary"
											plain
											round
											class="table-btn"
											icon="el-icon-video-camera-solid"
											@click="doHandler(row, 'play')"
											>回放
										</el-button>
									</template>
								</vxe-table-column>
							</vxe-table>
						</div>
						<div class="w-table-footer">
							<vxe-pager
								size="mini"
								@page-change="videoPageChange"
								:current-page="videoPage"
								:page-size="videoPageSize"
								:total="videoTotal"
								:layouts="['PrevPage', 'JumpNumber', 'NextPage', 'FullJump', 'Sizes', 'Total']"
								class="text-center"
								:page-sizes="[10, 20, 50, 100]"
							>
							</vxe-pager>
						</div>
					</div>
				</div>
			</div>
		</div>

		<!-- 返回上一步 -->
		<div class="footer" v-if="showDetails">
			<el-button
				type="primary"
				size="small"
				class="btn-blue"
				@click="
					showDetails = false
					getCameraList()
				"
			>
				<svg-icon icon-class="return" class="mr5" />
				返回上一步
			</el-button>
		</div>

		<!-- 添加监控设备弹窗 -->
		<el-dialog :title="cameraObj.title" :visible.sync="cameraObj.show" width="800px" :close-on-click-modal="false" center @close="dialogClose">
			<el-form :model="cameraForm" ref="cameraForm" label-width="120px" :rules="cameraRule" size="small">
				<el-row :gutter="10">
					<el-col :span="20" :offset="2">
						<el-form-item label="所属场地">
							<el-input disabled v-model.trim="msgObj.sname" maxlength="50" show-word-limit></el-input>
						</el-form-item>
					</el-col>
					<el-col :span="20" :offset="2">
						<el-form-item label="所属会议室" disabled>
							<el-input disabled v-model.trim="metObj.sname" maxlength="50" show-word-limit></el-input>
						</el-form-item>
					</el-col>
					<el-col :span="20" :offset="2">
						<el-form-item label="设备品牌" prop="brand">
							<el-input v-model.trim="cameraForm.brand" placeholder="请输入" maxlength="50" show-word-limit></el-input>
						</el-form-item>
					</el-col>
					<el-col :span="20" :offset="2">
						<el-form-item label="设备型号" prop="model">
							<el-input v-model.trim="cameraForm.model" placeholder="请输入" maxlength="50" show-word-limit></el-input>
						</el-form-item>
					</el-col>
					<el-col :span="20" :offset="2">
						<el-form-item label="设备序列号" prop="serialNo">
							<el-input v-model.trim="cameraForm.serialNo" placeholder="请输入" maxlength="50" show-word-limit></el-input>
						</el-form-item>
					</el-col>
					<el-col :span="20" :offset="2">
						<el-form-item label="录像机IP" prop="cameraIp">
							<el-input v-model.trim="cameraForm.cameraIp" placeholder="请输入" maxlength="50" show-word-limit></el-input>
						</el-form-item>
					</el-col>
					<el-col :span="20" :offset="2">
						<el-form-item label="录像机账号" prop="cameraNo">
							<el-input v-model.trim="cameraForm.cameraNo" placeholder="请输入" maxlength="50" show-word-limit></el-input>
						</el-form-item>
					</el-col>
					<el-col :span="20" :offset="2">
						<el-form-item label="录像机密码" prop="cameraCode">
							<el-input v-model.trim="cameraForm.cameraCode" placeholder="请输入" maxlength="50" show-word-limit></el-input>
						</el-form-item>
					</el-col>
					<el-col :span="20" :offset="2">
						<el-form-item label="录像机通道数" prop="portNum">
							<el-input placeholder="请输入正整数" type="number" v-model="cameraForm.portNum" v-input-filter:int> </el-input>
						</el-form-item>
					</el-col>
					<el-col :span="20" :offset="2">
						<el-form-item label="通道序列号" prop="portSerial">
							<el-input v-model.trim="cameraForm.portSerial" placeholder="请输入" maxlength="50" show-word-limit></el-input>
						</el-form-item>
					</el-col>
					<el-col :span="20" :offset="2">
						<el-form-item label="通道号" prop="portNo">
							<el-input placeholder="请输入正整数" type="number" v-model="cameraForm.portNo" v-input-filter:int> </el-input>
						</el-form-item>
					</el-col>
					<el-col :span="20" :offset="2">
						<el-form-item label="安装位置" prop="location">
							<el-input v-model.trim="cameraForm.location" placeholder="请输入" maxlength="100" show-word-limit></el-input>
						</el-form-item>
					</el-col>
					<el-col :span="20" :offset="2">
						<el-form-item label="预览地址" prop="previewUrl">
							<el-input v-model.trim="cameraForm.previewUrl" placeholder="请输入" maxlength="200" show-word-limit></el-input>
						</el-form-item>
					</el-col>
					<el-col :span="20" :offset="2">
						<el-form-item label="设备状态" prop="status">
							<vxe-switch
								v-model="cameraForm.status"
								close-label="禁用"
								:close-value="0"
								open-label="启用"
								:open-value="1"
							></vxe-switch>
						</el-form-item>
					</el-col>
				</el-row>
			</el-form>
			<div slot="footer">
				<el-button class="btn" @click="doDialog('close')">取 消</el-button>
				<el-button type="primary" class="btn btn-blue" :loading="cameraObj.loading" @click="doDialog('submit')">确 定 </el-button>
			</div>
		</el-dialog>

		<!-- 视频播放弹窗 -->
		<el-dialog title="监控视频回放" :visible.sync="videoDialogVisible" width="1000px" :close-on-click-modal="false" @closed="videoClose" center>
			<div class="ezuikit-js">
				<div>
					<div id="video-container" style="height: 500px"></div>
				</div>
			</div>
		</el-dialog>
	</div>
</template>
<script>
import { mapState } from 'vuex'
import * as API from '@/api/modules/fieldManagement'

import { EZUIKitPlayer } from 'ezuikit-js/ezuikit.js'
var player = null

export default {
	name: 'Camera-Management',
	components: {},
	props: {
		adressObj: {
			type: Object,
			default: () => ({})
		},
		meetingObj: {
			type: Object,
			default: () => ({})
		}
	},
	data() {
		return {
			cameraData: [], //摄像头列表
			tableShow: true, //表格展示
			cameraObj: {
				title: '',
				show: false,
				loading: false,
				type: ''
			},
			cameraForm: {
				brand: '', //摄像头品牌
				model: '', //摄像头型号
				serialNo: '', //摄像头编号
				cameraIp: '', //设备ip
				cameraNo: '', //录像机账号
				cameraCode: '', //录像机密码
				portNum: '', //通道数
				portNo: '', //通道号
				portSerial: '', //通道序列号
				location: '', //摆放位置
				previewUrl: '', // 预览地址
				status: 1 //状态 0：禁用 1：启用
			},
			cameraRule: {
				brand: [{ required: true, message: '不能为空...' }],
				model: [{ required: true, message: '不能为空...' }],
				serialNo: [{ required: true, message: '不能为空...' }],
				cameraIp: [{ required: true, message: '不能为空...' }],
				cameraNo: [{ required: true, message: '不能为空...' }],
				cameraCode: [{ required: true, message: '不能为空...' }],
				portSerial: [{ required: true, message: '不能为空...' }],
				portNum: [{ required: true, message: '通道数不能为空', trigger: 'blur' }],
				portNo: [{ required: true, message: '通道号不能为空', trigger: 'blur' }],
				location: [{ required: true, message: '不能为空...' }],
				previewUrl: [{ required: true, message: '不能为空...' }]
			},
			loading: false,
			showDetails: false,
			viewObj: {},
			videoData: [],
			msgObj: {},
			metObj: {},
			cameraPage: 1,
			cameraPageSize: 10,
			cameraTotal: 0,
			videoPage: 1,
			videoPageSize: 10,
			videoTotal: 0,
			// 视频查看
			videoDialogVisible: false,
			player: null,
			videoSrc: ''
		}
	},
	created() {
		// 获取摄像头列表
		this.getCameraList()
		this.sId == '' ? this.goBack() : ''
		if (this.adressObj.id) {
			this.$setSessionItem('adressObj', JSON.stringify(this.adressObj))
		}
		if (this.meetingObj.id) {
			this.$setSessionItem('meetingObj', JSON.stringify(this.meetingObj))
		}
		this.msgObj = JSON.parse(this.$getSessionItem('adressObj'))
		this.metObj = JSON.parse(this.$getSessionItem('meetingObj'))
	},
	methods: {
		// 获取摄像头列表
		getCameraList(page) {
			this.loading = true
			API.selMeetingCameraInfoList({
				meetingId: this.mId,
				current: page || this.cameraPage,
				size: this.cameraPageSize
			})
				.then((res) => {
					this.cameraData = res.data.records
					this.cameraTotal = parseInt(res.data.total) || 0
					this.loading = false
				})
				.catch(() => {
					this.loading = false
				})
		},

		// 添加监控设备
		addCamera() {
			this.cameraObj.show = true
			this.cameraObj.title = '添加监控设备'
			this.cameraObj.type = 'add'
		},

		// 监控设备状态改变
		statusChange(row) {
			let status = row.status
			API.changeStatus({
				id: row.id,
				status: status
			}).then(() => this.getCameraList())
		},
		// 点击事件
		doClick(row, type) {
			if (type == 'edit') {
				this.cameraForm = this.$utils.clone(row, true)
				this.cameraObj.show = true
				this.cameraObj.title = '编辑监控设备'
				this.cameraObj.type = 'edit'
			} else {
				this.showDetails = true
				this.viewObj = this.$utils.clone(row, true)
				this.getCameraDetailList(1)
			}
		},

		// 摄像头详情列表
		getCameraDetailList(page) {
			this.videoData = []
			this.loading = true
			let params = {
				id: this.viewObj.id,
				current: page || this.videoPage,
				size: this.videoPageSize
			}
			API.getVideoPageOfMonitor(params)
				.then((res) => {
					this.videoData = res.data.records
					this.videoTotal = parseInt(res.data.total) || 0
					this.loading = false
				})
				.catch(() => {
					this.loading = false
				})
		},

		// 弹窗操作
		doDialog(type) {
			if (type == 'submit') {
				this.$refs.cameraForm.validate((valid) => {
					if (valid) {
						this.cameraObj.loading = true
						let params = this.$utils.clone(this.cameraForm, true)
						params.meetingId = this.mId
						params.siteId = this.sId
						if (this.cameraObj.type == 'add') {
							delete params.updateUserid
							params.createUserid = this.userInfo.createUserid
						} else {
							delete params.createUserid
							params.updateUserid = this.userInfo.createUserid
						}
						API.addOrEditMeetingCameraInfo(params)
							.then((res) => {
								this.cameraObj.loading = false
								if (res.operationCode == 0) {
									this.$message.warning(res.msg)
									return
								}
								this.$message.success(res.msg)
								this.getCameraList()
								this.$refs.cameraForm.resetFields()
								this.dialogClose()
							})
							.catch(() => {
								this.cameraObj.loading = false
							})
					} else {
						this.$message.error('请先完善表单！')
					}
				})
			} else {
				this.dialogClose()
			}
		},

		// 处理相关dialog
		dialogClose() {
			if (this.$refs.cameraForm) {
				this.$refs.cameraForm.resetFields()
			}
			this.cameraForm.id = ''
			this.cameraObj.title = ''
			this.cameraObj.show = false
			this.cameraObj.type = ''
		},

		// 返回上一级
		goBack() {
			this.$router.replace({
				path: '/redirect' + this.$route.path,
				params: { id: this.companyId },
				query: {
					type: 'Area'
				}
			})
		},

		// 录像信息表格处理
		doHandler(row, type) {
			let playParams = {
				monitorId: row.id,
				tenantId: row.tenantId
			}
			API.getVideoPlay(playParams)
				.then((res) => {
					if (!!res.data.accessToken && !!res.data.url) {
						// url 拼接截取时间
						let startTime = this.$utils.toDateString(row.captureStartTime, 'yyyyMMddHHmmss')
						let endTime = this.$utils.toDateString(row.captureEndTime, 'yyyyMMddHHmmss')
						res.data.url = `${res.data.url}?begin=${startTime}&end=${endTime}`
						this.videoDialogVisible = true
						setTimeout(() => {
							this.init(res.data.accessToken, res.data.url)
						}, 1000)
					} else {
						this.$message.warning(res.data)
					}
				})
				.catch((err) => {})
		},
		// 渲染
		init(accessToken, url) {
			if (player) {
				this.destroy()
			}

			player = new EZUIKitPlayer({
				id: 'video-container', // 视频容器ID
				accessToken,
				url,
				// simple: 极简版; pcLive: pc直播; pcRec: pc回放; mobileLive: 移动端直播; mobileRec: 移动端回放;security: 安防版; voice: 语音版;
				template: 'pcRec',
				height: 500,
				handleError: (error) => {
					console.error('handleError', error)
				},
				// quality: 6, //
				language: 'zh', // zh | en
				// staticPath: "./ezuikit_static", // 如果想使用本地静态资源，请复制根目录下ezuikit_static 到当前目录下， 然后设置该值
				decoderType: 'auto',
				scaleMode: 1, // 默认 0 完全填充窗口，会有拉伸 1: 等比适配 2: 等比完全填充窗口, 超出隐藏 @sine 8.2.0
				env: {
					// https://open.ys7.com/help/1772?h=domain
					// domain默认是 https://open.ys7.com, 如果是私有化部署或海外的环境，请配置对应的domain
					// The default domain is https://open.ys7.com If it is a private deployment or overseas (outside of China) environment, please configure the corresponding domain
					domain: 'https://open.ys7.com'
				},
				// staticPath:"https://openstatic.ys7.com/ezuikit_js/v8.1.9/ezuikit_static",
				// 日志打印设置
				// loggerOptions: {
				// 	// player.setLoggerOptions(options)
				// 	level: 'INFO', // INFO LOG  WARN  ERROR
				// 	name: 'ezuikit',
				// 	showTime: true
				// },
				// 视频流的信息回调类型
				/**
				 * 打开流信息回调，监听 streamInfoCB 事件
				 * 0 : 每次都回调
				 * 1 : 只回调一次
				 * 注意：会影响性能
				 * 默认值 1
				 */
				streamInfoCBType: 1
				// v8.1.10
				// 自定义清晰度 默认 null, 如果有值 sdk 内部不在进行获取, null 默认使用接口获取的清晰度列表, videoLevelList.length === 0 不展示清晰度控件 sdk 内部不在进行获取, videoLevelList.length > 0 展示控件 sdk 内部不在进行获取
				// videoLevelList: [
				//   { level: 1, name: "标清", streamTypeIn: 2 }, // 需要保证支持子码流 (streamTypeIn=2)
				//   { level: 2, name: "高清", streamTypeIn: 1 },
				// ],
				// videoLevelList: [
				//   { level: -1, name: "标清", streamTypeIn: 2 }, // 8.1.17 开始 当 level 的值小于 0时， 不在向设备发送指令，仅根据 streamTypeIn 切换码流 （请保证 streamTypeIn 对应的码流存在）
				//   { level: -2, name: "高清", streamTypeIn: 1 }, // 8.1.17 开始 当 level 的值小于 0时， 不在向设备发送指令，仅根据 streamTypeIn 切换码流 （请保证 streamTypeIn 对应的码流存在）
				// ]
			})

			console.warn('init player', player)

			// 8.1.x 事件监听
			// player.eventEmitter.on(EZUIKitPlayer.EVENTS.videoInfo, (info) => {
			//   console.warn("eventEmitter videoInfo", info);
			// });
			// 8.2.x 事件监听
			player.on(EZUIKitPlayer.EVENTS.videoInfo, (info) => {
				console.warn('videoInfo', info)
			})

			// 8.1.x 事件监听
			// player.eventEmitter.on(EZUIKitPlayer.EVENTS.audioInfo, (info) => {
			//   console.warn("eventEmitter audioInfo", info);
			// });
			// 8.2.x 事件监听
			player.on(EZUIKitPlayer.EVENTS.audioInfo, (info) => {
				console.warn('audioInfo', info)
			})

			// 首帧渲染成功
			// first frame display
			// 8.1.x 事件监听
			// player.eventEmitter.on(EZUIKitPlayer.EVENTS.firstFrameDisplay, () => {
			//     console.warn("eventEmitter firstFrameDisplay ");
			// });
			// 8.2.x 事件监听
			player.on(EZUIKitPlayer.EVENTS.firstFrameDisplay, () => {
				console.warn('firstFrameDisplay ')
			})

			// 8.1.x 事件监听
			// player.eventEmitter.on(EZUIKitPlayer.EVENTS.streamInfoCB, (info) => {
			//   console.warn("eventEmitter streamInfoCB ", info);
			// });
			// 8.2.x 事件监听
			player.on(EZUIKitPlayer.EVENTS.streamInfoCB, (info) => {
				console.warn('streamInfoCB ', info)
			})

			window.player = player
		},
		destroy() {
			if (player) {
				player.destroy().then((data) => {
					console.log('promise 获取 数据', data)
				})
				player = null
			}
		},
		// 弹窗关闭
		videoClose() {
			this.destroy()
			this.videoDialogVisible = false
		},

		// 分页切换
		cameraPageChange({ currentPage, pageSize }) {
			this.cameraPage = currentPage
			this.cameraPageSize = pageSize

			this.getCameraList()
		},

		videoPageChange({ currentPage, pageSize }) {
			this.videoPage = currentPage
			this.videoPageSize = pageSize

			this.getCameraDetailList()
		},

		// 打开预览地址
		openUrl(url) {
			if (!!url) {
				window.open(url, '_blank')
			}
		}
	},
	computed: {
		...mapState('menu', {
			roleBtns: (state) => state.roleBtns
		}),
		...mapState('app', {
			clientSize: (state) => state.clientSize
		}),
		...mapState('user', {
			userInfo: (state) => state.userInfo
		}),
		mId() {
			return this.$route.query.meetingId
		},
		sId() {
			return this.$route.query.siteId
		},
		companyId() {
			return this.$route.query.companyId
		}
	},
	beforeDestroy() {
		this.destroy()
	},
	// reloadColumn
	watch: {
		clientSize(val, oldval) {
			if (val.height != oldval.height) {
				this.tableShow = false
				setTimeout(() => {
					this.tableShow = true
				}, 50)
			}
		}
	}
}
</script>
<style lang="less" scoped>
.Camera-Management-layout {
	height: 100%;

	.header-msg {
		line-height: 30px;
		padding-bottom: 20px;
		border-bottom: 1px solid #202020;

		span {
			font-size: 14px;
		}

		span:first-child {
			display: inline-block;
			width: 120px;
			text-align: right;
			color: #999999;
		}

		span:last-child {
			color: #202020;
		}
	}

	.header-title {
		font-size: 18px;
		font-weight: bold;
	}

	.footer {
		position: absolute;
		top: 88px;
		right: 15px;
		width: 150px;
		text-align: right;
		background-color: #f7f7f7;

		.el-button {
			height: 28px !important;
			font-size: 12px !important;
			padding: 7px 15px !important;
			color: #fff;
		}
	}

	.blue-text {
		color: #2671cc !important;
		cursor: pointer;
	}
}

.vxe-switch.is--disabled {
	opacity: 1;

	/deep/ .vxe-switch--button {
		cursor: pointer !important;
	}
}

/deep/ .is--on {
	.vxe-switch--button {
		background-color: #2671cc !important;
	}
}

.red {
	color: red !important;
}

.green {
	color: green !important;
}
/deep/ .ezplayer-control-date {
	display: none;
}
</style>
